/**
 * @param {string} path 
 * @returns 
 */
export const isInternalLink = (path) => /^\/bank\/red/gi.test(path);
